import { z } from 'zod';

// form validation rules
export const SalesTotalSchema = z.object({
  costs: z.number(),
  sales: z.number(),
  taxes: z.number(),
  transactions: z.number(),
});

export type SalesTotal = z.infer<typeof SalesTotalSchema>;
